export default __webpack_public_path__ + "static/media/screenshot.08c3095d.png";